import { thanos26GetJson, thanos26PostJson } from "./thanos26Client";

const URL_SETTTINGS = "manager/Settings";

async function getAllSettings(): Promise<any> {
    return thanos26GetJson(URL_SETTTINGS);
}

async function getSetting(key: string): Promise<any> {
    return thanos26GetJson(URL_SETTTINGS, { key: key });
}

async function settSetting(key: string, body: any): Promise<any> {
    return thanos26PostJson(URL_SETTTINGS, { key: key }, body);
}

export default { getAllSettings, getSetting, settSetting };
